import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getIcon } from '@ohif/ui';
import { getGpUser, clearGpSession } from '../../Utils/gpAuth';
import { getInitials } from '../../Utils/utils';

const GpHeader: React.FC = () => {
  const navigate = useNavigate();
  const gpUser = getGpUser();

  const handleLogout = () => {
    clearGpSession();
    navigate('/gp/login');
  };

  return (
    <div className="page__head">
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
        <div className="page__head__logo" style={{ display: 'flex', alignItems: 'center' }}>
          <div className="page__head__logo__img">
            {getIcon('logoWeb10')}
          </div>
        </div>
        <span
          style={{
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: '#1ea9ea',
            background: 'rgba(30,169,234,0.12)',
            border: '1px solid rgba(30,169,234,0.35)',
            borderRadius: '999px',
            padding: '4px 12px',
            whiteSpace: 'nowrap',
          }}
        >
          GP Portal
        </span>
      </div>

      <div className="page__head__actions">
        {gpUser && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span
              style={{
                background: 'linear-gradient(135deg, #1ea9ea 0%, #0e7bb8 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '34px',
                height: '34px',
                borderRadius: '50%',
                fontSize: '13px',
                fontWeight: 600,
                color: '#fff',
                flexShrink: 0,
              }}
            >
              {getInitials(gpUser.name)}
            </span>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '13px', color: '#fff', fontWeight: 600, lineHeight: 1.3 }}>
                {gpUser.name}
              </span>
              <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.45)', lineHeight: 1.3 }}>
                Provider No. {gpUser.providerNumber}
              </span>
            </div>
          </div>
        )}
        <button
          type="button"
          className="btn btn__white btn__outlined"
          onClick={handleLogout}
          style={{ fontSize: '13px', padding: '7px 16px', borderRadius: '6px' }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default GpHeader;
